<template>
  <!--最外层包裹-->
  <div class="wrap" ref="index">
    <Topnav></Topnav>
    <div class="wrap-lunbo">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(item,index) in resistance"  data-index="index" class="enlarge" :key="index">
          <img :src="item.basicThumbnail" @touchend.prevent="handleTab(index)">
        </swiper-slide>
      </swiper>
      <div class="wrap-lunbo-index">
        <span>{{imgindex+1}}/{{resistance.length}}</span>
      </div>
    </div>
    <div class="wrap-content">
      <h3  v-html='Title'></h3>
      <div  v-html='content'></div>
      <div class="wrap-content-ckqw">
        <span  @touchend.prevent="handleHerf(id)">
          阅读全文
         <div></div>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
  import  Topnav from '@/components/topnav.vue'
  import {TELLASTORY} from '@/config/global.js'
  import {getUserToken} from '@/config/config.js'
  import {getjlsdata} from '@/api/generalsecretary.js'
  import util from '@/assets/js/util'
  export default {
    data() {
      let self = this
      return {
        resistance:[],
        swiperOption: {
            notNextTick: true,
            initialSlide: 0,
            direction: 'horizontal',
            autoplay: {
              delay: 5000,
              stopOnLastSlide: false,
              disableOnInteraction: true
            },
            on: {
              slideChangeTransitionStart: function() {
                self.imgindex =  this.activeIndex
                self.handleNewShow(self.imgindex )
              },
            },
            loopedSlides: 0,
            loopAdditionalSlides: 0,
            slidesPerView: 1,
            observer: true,
            observeParents: true
          },
        Title: '',
        content: '',
        img: '',
        id: '',
        imgindex:0
      }
    },
    components:{
      Topnav
    },
    mounted() {
      getUserToken()
      this._initdata()
      this.handleNewShow(this.imgindex)
    },
    methods: {
      _initdata(){
        if (util.isEmpty(this.resistance)){
          getjlsdata().then(res => {
            if (res.length > 0) {
              if (!util.isEmpty(res) && this.resistance) {
                this.resistance = res;
                this.handleNewShow(0)
              } else {
                console.log('没有数据')
              }
            }
          }).catch((err) => {
            console.log(err, "4")
          })
        }
      },
      handleNewShow(num){
        this.Title = this.resistance[num].basicTitle;
        this.content = this.unescape(this.resistance[num].basicRoundup);
        this.img = this.resistance[num].basicThumbnail;
        this.id = this.resistance[num].basicId
      },
      unescape:function (html) {
        return html
          .replace(html ? /&(?!#?\w+;)/g : /&/g, '&amp;')
          .replace(/&lt;/g, "<")
          .replace(/&gt;/g, ">")
          .replace(/&quot;/g, "\"")
          .replace(/&#39;/g, "\'");
      },
      handleHerf(id) {
        let two = this.$router.resolve({
          path: `/Details/${id}&&1`,
        })
        window.open(two.href, '_blank');
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "index.scss";
</style>




// WEBPACK FOOTER //
// src/pages/Resistance/index.vue